import ComponentWithAnalytics from '@atlassian/jira-analytics-web-react/src/utils/component-with-analytics.tsx';
import FilterSearch from '@atlassian/jira-common-components-filter-search/src/main.tsx';

const FilterSearchWithAnalytics = ComponentWithAnalytics('filterSearch', {
	onChange: 'changed',
})(FilterSearch);

export default FilterSearchWithAnalytics;
